import "@/App.css";
import { ReactLenis } from "lenis/react";
import Brochure from "@/components/Brochure";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      <div className="App">
        <Brochure />
      </div>
    </ReactLenis>
  );
}

export default App;
